<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">
            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================ -->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Antrag-Daten</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <v-flex xs12 style=" font-size: 0.9em;">
                        <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
                    </v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        <br>Der Beginn ist frühestens am nächsten Tag möglich.
                        <br>Der Versicherungsbeginn sollte jedoch maximal einen Tag später sein, zu dem Ihre bisherige Versicherung aufgehoben wurde.
                        <br>
                    </Rechner-hint-col>

                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder
                        vierteljährlich gezahlt werden soll.
                        <br>Eine monatliche Zahlweise ist nicht möglich.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Daten der zu versichernden Person(en)</h6></v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row v-if="this.$route.query.tariffilter!='beamte'">
                    <Rechner-hint-col>
                        Sie können wählen, ob sie nur sich selbst oder ihre Familie versichern wollen.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.rs_deckungs_art" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        xxx
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.rs_beruf_status" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row v-if="this.$route.query.tariffilter!='beamte'">
                    <Rechner-hint-col>
                        xxxx
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.rs_selbst_beteiligung" v-model="value.fieldValues"        direction="row"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <!--
                                <v-layout row>
                                    <Rechner-hint-col>
                                        Bietet zum Zeitpunkt des Eintritts des Versicherungsfalls
                                        ein anderer, zum Betrieb in Deutschland zugelassener
                                        Versicherer eine rechtschutzhaftpflicht-Versicherung mit einem
                                        weitergehenden Versicherungsschutz an, als es gemäß dem
                                        mit uns abgeschlossenen Vertrag der Fall ist, so
                                        erweitern wir für die bei uns versicherten Personen unsere
                                        Leistung dementsprechend im Rahmen der mit uns
                                        vereinbarten Versicherungssumme.
                                    </Rechner-hint-col>
                                    <v-flex xs10>
                                        <Rechner-field-col class=""
                                                           :fielddef="fieldDefs.rs_best_preis_garantie"
                                                           v-model="value.fieldValues"
                                                           direction="row"
                                                           :$v="$v"
                                        ></Rechner-field-col>
                                    </v-flex>
                                </v-layout>
                                -->
                <!------------------------------------------------------------------------------------------------------------>

                <!--============================================================================================================-->
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import slideMixin from '../stepMixin'
    import _ from 'lodash'
    //import VueUploadComponent from 'vue-upload-component'
    //import VBtn from 'vuetify/src/components/VBtn/VBtn'
    //import {mapState} from 'vuex'

    /*
    const STATUS_INITIAL = 0
    const STATUS_SAVING = 1
    const STATUS_SUCCESS = 2
    const STATUS_FAILED = 3
*/
    export default {
        //========================================================================================================
        name: 'Step_rechtschutz_I',
        label: 'rechtschutz Daten',
        label2: 'rechtschutz<br>Daten',


        fieldKeys: [
            'rs_deckungs_art',
            'rs_beruf_status',
            'rs_selbst_beteiligung',

            'vertrag_zahlungsweise',
            'vertrag_beginn',
        ],
        //========================================================================================================
        data: function () {
            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}


            return {
                fieldDefs: fieldDefs_OVERRIDE,

            }
        }, //========================================================================================================
        mixins: [slideMixin],
        //========================================================================================================
        computed: {},  //===========================================================================================================
        methods: {

            test: function () {
                this.$v.$touch()
                console.log("TEST1")
            },

        },  //===========================================================================================================
        watch: {

            value: {
                handler: function (newVal, oldVal) {
                    console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
                    console.log('WATCHER fieldValues in ', this.$options.label)
                    // var fD = this.fieldDefs
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld
                    var earlyExit = true

                    // console.log('TEST ', fV.rechtschutz_art_pkw_nfz, (fV.rechtschutz_art_pkw_nfz === "PKW") * 1)

                    for (var key in fV) {
                        console.log('Watcher TEST :', key, ":", fV[key], " -> ", fVold[key])
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            this.update_Ort_by_PLZ(key)
                        }
                    }
                    if (earlyExit === true) {
                        console.log('NO changes -> early EXIT')
                        return
                    }
                    console.log('FOUND changes -> check handlers ...')

                    //----------------------------------------------------------------------------
                    // -> hier evtl. Reaktion auf Änderungen von Form-Values
                    /*------------------------------------------------------------------------------------*/


                    if (fV.vertrag_beginn != fVold.vertrag_beginn && fV.vertrag_beginn > '' && fV.versnehm_geburtsdatum > '') {
                        this.$v.$touch()
                    }

                    //----------------------------------------------------------------------------
                    if (this.$route.query.tariffilter=="beamte" && this.value.fieldValues.rs_deckungs_art != 'familie') {
                        this.value.fieldValues.rs_deckungs_art = 'familie'
                    }
                    if (this.$route.query.tariffilter=="beamte" && this.value.fieldValues.rs_selbst_beteiligung != '1') {
                        this.value.fieldValues.rs_selbst_beteiligung = '250'
                    }
                    /*------------------------------------------------------------------------------------*/
                    this.frmValuesOld = _.assign({}, fV)

                },
                deep: true,

            },
        }
        , //========================================================================================================
        /* ohter components are programmatically setted my step-mixin*/
        components: {}
        ,
        //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        // HOOKS:
        /* programmatically setted by step-mixin*/
        mounted: function () {
            //  this.upload_reset()
            //  this.upload_timeTest()

        }

        ,
        //===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
